import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { Drawer, DrawerTitle, DrawerTrigger, DrawerContent, DrawerClose } from "@core/components/ui/Drawer";
import { Button } from "@core/components/ui/Button";
import UserInfoAfterLogin from "@features/auth/component/UserInfoAfterLogin";
import UserInfoBeforeLoginMobile from "@features/auth/component/UserInfoBeforeLoginMobile";
import { useAuthStore } from "@core/stores/authStore";
import { UserRound, X } from "lucide-react";
import { cn } from "@core/utils/domUtil";

export default function UserMobile() {
  const isLogin = useAuthStore((state) => state.isLogin);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <Drawer direction="right" open={isOpen} onOpenChange={setIsOpen} handleOnly={true}>
      <DrawerTrigger asChild>
        <Button variant="icon" className={cn("flex h-[36px] w-[36px] items-center justify-center rounded-[50%] p-0!", isLogin && "bg-purple [&_svg]:stroke-white")}>
          <UserRound />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="px-[25px]" aria-describedby={undefined}>
        {/* 타이틀 - 접근성 준수를 위해 추가 및 숨김 처리 */}
        <DrawerTitle className="hidden">{isLogin ? "개인화 영역" : "로그인 영역"}</DrawerTitle>
        <div className="flex justify-end py-[15px]">
          <DrawerClose asChild>
            <Button variant="text" className={cn("flex h-[36px] w-[36px] shrink-0 items-center justify-center p-0!")}>
              <X className="size-[32px]" />
            </Button>
          </DrawerClose>
        </div>
        {isLogin ? (
          <div className="my-auto pb-[60px]">
            <UserInfoAfterLogin />
          </div>
        ) : (
          <UserInfoBeforeLoginMobile />
        )}
      </DrawerContent>
    </Drawer>
  );
}
